export const FULL_TIME_STUDENT_FIELD_NAMES = {
  marriedJointReturn: 'marriedJointReturn',
  singleParentDependantChild: 'singleParentDependantChild',
  jobTrainingProgram: 'jobTrainingProgram',
  TANFAssistance: 'TANFAssistance',
  fosterProgram: 'fosterProgram',
};
